module.exports = __webpack_public_path__ + "img/y-239.d85358dd.png";